import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import Select from '@mui/material/Select';
import { FormControl } from '@mui/base';
import { MenuItem } from '@mui/material';

const minDistance = 5;

interface IRangeSliderInputFieldProps {
  onCommittedCallback?: (startValue: number, endValue: number) => void;
}

const RangeSlider = ({
  onCommittedCallback
}: IRangeSliderInputFieldProps): JSX.Element => {
  const [values, setValues] = useState<[number, number]>([0, 100]);

  const handleChange = (
    _event: Event,
    newValue: number | number[],
    activeThumb: number
  ): void => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (activeThumb === 0) {
      setValues([Math.min(newValue[0], values[1] - minDistance), values[1]]);
    } else {
      setValues([values[0], Math.max(newValue[1], values[0] + minDistance)]);
    }
  };

  const handleSliderClose = (): void => {
    if (onCommittedCallback) {
      onCommittedCallback(values[0], values[1]);
    }
  };

  return (
    <>
      <Box>
        <FormControl>
          <Select
            value={''}
            fullWidth
            displayEmpty
            sx={{
              height: '48px',
              width: '100%',
              borderRadius: '8px'
            }}
            onClose={handleSliderClose}
          >
            <MenuItem sx={{ display: 'none' }} value="">
              <em
                style={{
                  fontFamily: 'Be Vietnam Pro',
                  color: '#5F6368',
                  fontStyle: 'normal',
                  fontSize: '16px',
                  lineHeight: '20px',
                  fontWeight: '500'
                }}
              >
                Total Man Hours per Week
              </em>
            </MenuItem>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                margin: '10px'
              }}
            >
              <Box
                sx={{
                  minHeight: '34px',
                  minWidth: '34px',
                  borderRadius: '8px',
                  border: '1px solid #DBDBDB',
                  minBlockSize: 'fit-content',
                  padding: '5px'
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Be Vietnam Pro',
                    fontSize: '16px',
                    fontWeight: 400,
                    color: '#1A1B1F',
                    textAlign: 'center'
                  }}
                >
                  {values[0]}
                </Typography>
              </Box>
              <Slider
                sx={{
                  margin: '0px 20px',
                  '.MuiSlider-valueLabel': {
                    display: 'none'
                  }
                }}
                getAriaLabel={() => 'Minimum distance'}
                value={values}
                onChange={handleChange}
                valueLabelDisplay="auto"
                disableSwap
                shiftStep={30}
                step={5}
                marks
                min={0}
                max={100}
              />
              <Box
                sx={{
                  minHeight: '34px',
                  minWidth: '34px',
                  borderRadius: '8px',
                  border: '1px solid #DBDBDB',
                  minBlockSize: 'fit-content',
                  padding: '5px'
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Be Vietnam Pro',
                    fontSize: '16px',
                    fontWeight: 400,
                    color: '#1A1B1F',
                    textAlign: 'center'
                  }}
                >
                  {values[1]}
                </Typography>
              </Box>
            </Box>
          </Select>
        </FormControl>
      </Box>
    </>
  );
};

export default RangeSlider;
